/**
 * Menú público (navbar móvil + bottom nav): items con icono CMS.
 */
import contentFallback from "../data/content.json";

/** Iconos Lucide por defecto (mismo criterio que BottomNav/Navbar histórico). */
export const DEFAULT_NAV_ICONS_BY_LABEL = {
  Inicio: "lucide:Home",
  Nosotros: "lucide:Users",
  Credibilidad: "lucide:ShieldCheck",
  Servicios: "lucide:Briefcase",
  Calculadoras: "lucide:Calculator",
  Investigación: "lucide:FlaskConical",
  LABSYSO: "lucide:Microscope",
  Cotizar: "lucide:Receipt",
};

export function createNavItem(partial = {}) {
  return {
    id: partial.id || `nav-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    label: partial.label || "Nuevo",
    link: partial.link || "/",
    icon: partial.icon || "lucide:Circle",
    showInMobileMenu: partial.showInMobileMenu !== false,
    showInBottomNav: partial.showInBottomNav !== false,
  };
}

export function buildDefaultNavigationItems() {
  return (contentFallback.navigation || []).map((item, idx) =>
    createNavItem({
      id: `nav-${idx}-${String(item.label || "item").toLowerCase().replace(/\s+/g, "-")}`,
      label: item.label,
      link: item.link,
      icon: DEFAULT_NAV_ICONS_BY_LABEL[item.label] || "lucide:Circle",
      showInMobileMenu: true,
      showInBottomNav: item.label !== "Inicio",
    })
  );
}

export function normalizeNavigationDoc(raw) {
  const base = raw && typeof raw === "object" ? raw : {};
  let items = Array.isArray(base.items) ? base.items : null;
  if (!items || items.length === 0) {
    items = buildDefaultNavigationItems();
  } else {
    items = items.map((row, idx) =>
      createNavItem({
        id: row.id || `nav-${idx}`,
        label: row.label,
        link: row.link,
        icon: row.icon || DEFAULT_NAV_ICONS_BY_LABEL[row.label] || "lucide:Circle",
        showInMobileMenu: row.showInMobileMenu !== false,
        showInBottomNav: row.showInBottomNav !== false,
      })
    );
  }
  return {
    ...base,
    items,
    formation: {
      label: base.formation?.label || "Formación",
      icon: base.formation?.icon || "lucide:GraduationCap",
      enabled: base.formation?.enabled !== false,
      url: String(base.formation?.url || "https://academia.agdysa.com/").trim() ||
        "https://academia.agdysa.com/",
    },
  };
}

export function formatNavLink(link) {
  if (link === "#inicio" || link === "/") return "/";
  let path = String(link || "/").replace("#", "");
  if (!path.startsWith("/")) path = `/${path}`;
  if (path === "/riesgo") return "/contacto";
  return path;
}
